
import { useState } from 'react';
import Navbar from '../services/components/Navbar';
import Footer from '../services/components/Footer';
import SEOHead from '../../components/SEOHead';

export default function SocialPage() {
  const [copiedPost, setCopiedPost] = useState<string | null>(null);

  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

  const schema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Social Media - Aire University",
    "description": "Follow Aire University on social media for Airbnb hosting tips, property transformation stories, and revenue optimization strategies. Connect with us on TikTok, Instagram, Facebook, Pinterest, YouTube, and LinkedIn.",
    "url": `${siteUrl}/social`
  };

  const socialPosts = [
    {
      platform: 'TikTok',
      icon: 'ri-tiktok-fill',
      color: 'from-[#000000] to-[#00F2EA]',
      bgColor: 'bg-[#000000]',
      profileUrl: 'https://www.tiktok.com/@aireuniversity',
      postUrl: 'https://www.tiktok.com/@aireuniversity/video/7234567890123456789',
      postImage: 'https://public.readdy.ai/ai/img_res/11b29c180ca6a2ebd5d24a8c7f735bf1.jpg',
      caption: '✨ From outdated to outstanding! Watch this living room transformation that increased booking rates by 40%. Which design element is your favorite? 🏠💫 #AirbnbTransformation #InteriorDesign #PropertyManagement',
      stats: { views: '125K', likes: '8.2K', comments: '342' }
    },
    {
      platform: 'Instagram',
      icon: 'ri-instagram-line',
      color: 'from-[#833AB4] via-[#FD1D1D] to-[#F77737]',
      bgColor: 'bg-gradient-to-br from-[#833AB4] via-[#FD1D1D] to-[#F77737]',
      profileUrl: 'https://www.instagram.com/aireuniversity',
      postUrl: 'https://www.instagram.com/p/ABC123xyz/',
      postImage: 'https://readdy.ai/api/search-image?query=Stunning%20modern%20Airbnb%20kitchen%20renovation%20with%20white%20cabinets%2C%20marble%20countertops%2C%20stainless%20steel%20appliances%2C%20pendant%20lighting%2C%20professional%20real%20estate%20photography%2C%20bright%20airy%20atmosphere%2C%20clean%20contemporary%20design%2C%20Instagram%20aesthetic&width=600&height=600&seq=social-instagram-001&orientation=squarish',
      caption: '🏡 Kitchen goals achieved! This stunning renovation helped our client reach Superhost status in just 3 months. Swipe to see the before photos! ➡️\\n\\n📍 Newark, DE | 💰 ROI: 156%\\n\\n#AirbnbHost #KitchenRenovation #PropertyInvestment #SuperhostStatus #AireUniversity',
      stats: { likes: '2.4K', comments: '87', shares: '156' }
    },
    {
      platform: 'Facebook',
      icon: 'ri-facebook-fill',
      color: 'from-[#1877F2] to-[#0C63D4]',
      bgColor: 'bg-[#1877F2]',
      profileUrl: 'https://www.facebook.com/aireuniversity',
      postUrl: 'https://www.facebook.com/aireuniversity/posts/123456789',
      postImage: 'https://readdy.ai/api/search-image?query=Professional%20Airbnb%20property%20exterior%20with%20beautiful%20landscaped%20front%20yard%2C%20modern%20home%20facade%2C%20welcoming%20entrance%2C%20professional%20real%20estate%20photography%2C%20blue%20sky%2C%20green%20lawn%2C%20flowers%2C%20curb%20appeal&width=800&height=500&seq=social-facebook-001&orientation=landscape',
      caption: '🎉 SUCCESS STORY ALERT! 🎉\\n\\nMeet Sarah, who transformed her Newark home into a thriving Airbnb with our Platinum Package. In just 6 months:\\n\\n✅ $47,000 in revenue\\n✅ 4.98 star rating\\n✅ 89% occupancy rate\\n✅ Superhost status achieved\\n\\nReady to write your own success story? Book a free consultation today! 📞 302-500-3373\\n\\n#AirbnbSuccess #PropertyManagement #PassiveIncome #RealEstateInvesting',
      stats: { likes: '1.8K', comments: '124', shares: '289' }
    },
    {
      platform: 'Pinterest',
      icon: 'ri-pinterest-fill',
      color: 'from-[#E60023] to-[#BD081C]',
      bgColor: 'bg-[#E60023]',
      profileUrl: 'https://www.pinterest.com/aireuniversity',
      postUrl: 'https://www.pinterest.com/pin/123456789/',
      postImage: 'https://readdy.ai/api/search-image?query=Beautiful%20Airbnb%20bedroom%20interior%20design%20mood%20board%20collage%2C%20cozy%20modern%20bedroom%20styling%2C%20neutral%20color%20palette%2C%20textured%20bedding%2C%20decorative%20pillows%2C%20wall%20art%2C%20plants%2C%20Pinterest%20aesthetic%2C%20professional%20staging%20photography&width=600&height=900&seq=social-pinterest-001&orientation=portrait',
      caption: '🛏️ 5 Bedroom Design Tips That Boost Your Airbnb Bookings\\n\\n1. Layer textures for cozy vibes\\n2. Invest in quality bedding\\n3. Add ambient lighting\\n4. Keep it neutral but warm\\n5. Include thoughtful touches\\n\\nSave this pin for your next property makeover! 📌\\n\\n#AirbnbDesign #BedroomDecor #InteriorDesignTips #PropertyStyling #VacationRental',
      stats: { saves: '3.2K', views: '45K' }
    },
    {
      platform: 'YouTube',
      icon: 'ri-youtube-fill',
      color: 'from-[#FF0000] to-[#CC0000]',
      bgColor: 'bg-[#FF0000]',
      profileUrl: 'https://www.youtube.com/@aireuniversity',
      postUrl: 'https://www.youtube.com/watch?v=dQw4w9WgXcQ',
      postImage: 'https://readdy.ai/api/search-image?query=YouTube%20video%20thumbnail%20showing%20Airbnb%20property%20renovation%20time-lapse%2C%20before%20and%20after%20comparison%2C%20professional%20host%20presenting%2C%20bold%20text%20overlay%2C%20bright%20engaging%20colors%2C%20professional%20videography%2C%2016:9%20aspect%20ratio&width=800&height=450&seq=social-youtube-001&orientation=landscape',
      caption: '🎥 FULL PROPERTY TRANSFORMATION | $2,000 to $8,000/month\\n\\nWatch the complete journey of transforming a dated property into a 5-star Airbnb rental. We cover:\\n\\n• Permit applications\\n• Contractor negotiations\\n• Design decisions\\n• Furniture selection\\n• Listing optimization\\n• First booking!\\n\\nTimestamps in description 👇\\n\\n#AirbnbTransformation #PropertyRenovation #PassiveIncome',
      stats: { views: '87K', likes: '4.1K', subscribers: '+892' }
    },
    {
      platform: 'LinkedIn',
      icon: 'ri-linkedin-fill',
      color: 'from-[#0A66C2] to-[#004182]',
      bgColor: 'bg-[#0A66C2]',
      profileUrl: 'https://www.linkedin.com/company/aireuniversity',
      postUrl: 'https://www.linkedin.com/feed/update/urn:li:activity:1234567890',
      postImage: 'https://readdy.ai/api/search-image?query=Professional%20business%20infographic%20showing%20Airbnb%20revenue%20growth%20chart%2C%20data%20visualization%2C%20statistics%2C%20professional%20corporate%20design%2C%20clean%20modern%20layout%2C%20blue%20and%20white%20color%20scheme%2C%20business%20analytics&width=700&height=500&seq=social-linkedin-001&orientation=landscape',
      caption: "📊 Q4 2024 Short-Term Rental Market Insights\\n\\nOur data analysis of 500+ properties reveals:\\n\\n• Average nightly rates increased 12% YoY\\n• Occupancy rates stabilized at 73%\\n• Properties with professional design see 34% higher revenue\\n• Hosts using dynamic pricing earn 28% more\\n\\nThe short-term rental market continues to offer strong ROI for property owners who invest in professional setup and management.\\n\\nInterested in maximizing your property's potential? Let's connect.\\n\\n#RealEstate #PropertyManagement #Airbnb #Investment #Hospitality",
      stats: { reactions: '892', comments: '67', reposts: '134' }
    },
    {
      platform: 'Twitter',
      icon: 'ri-twitter-x-fill',
      color: 'from-[#000000] to-[#333333]',
      bgColor: 'bg-[#000000]',
      profileUrl: 'https://twitter.com/aireuniversity',
      postUrl: 'https://twitter.com/aireuniversity/status/1234567890',
      postImage: 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20Airbnb%20property%20photo%20with%20text%20overlay%2C%20clean%20design%2C%20professional%20photography%2C%20social%20media%20graphic%2C%20simple%20background%2C%20contemporary%20aesthetic%2C%20Twitter%20post%20format&width=700&height=400&seq=social-twitter-001&orientation=landscape',
      caption: '🔥 Hot take: Most Airbnb hosts leave 30-40% of potential revenue on the table.\\n\\nWhy? They skip these 3 things:\\n\\n1. Professional photography\\n2. Dynamic pricing strategy\\n3. Optimized listing copy\\n\\nWe help hosts capture that missing revenue. DM for a free property audit.\\n\\n#Airbnb #PropertyManagement #RevenueOptimization',
      stats: { retweets: '234', likes: '1.2K', replies: '89' }
    }
  ];

  const handleShare = (postUrl: string, platform: string) => {
    window.open(postUrl, '_blank', 'noopener,noreferrer');
  };

  const handleCopyLink = async (postUrl: string, platform: string) => {
    try {
      await navigator.clipboard.writeText(postUrl);
      setCopiedPost(platform);
      setTimeout(() => setCopiedPost(null), 2000);
    } catch (err) {
      console.error('Failed to copy link:', err);
      // Fallback for older browsers
      const textArea = document.createElement('textarea');
      textArea.value = postUrl;
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      try {
        document.execCommand('copy');
        setCopiedPost(platform);
        setTimeout(() => setCopiedPost(null), 2000);
      } catch (fallbackErr) {
        console.error('Fallback copy failed:', fallbackErr);
      }
      document.body.removeChild(textArea);
    }
  };

  return (
    <>
      <SEOHead
        title="Social Media | Follow Aire University on TikTok, Instagram, Facebook & More"
        description="Follow Aire University on social media for Airbnb hosting tips, property transformation stories, and revenue optimization strategies. Connect with us on TikTok, Instagram, Facebook, Pinterest, YouTube, LinkedIn, and Twitter."
        keywords="Aire University social media, Airbnb tips, property transformation, hosting advice, real estate social media, Newark DE"
        schema={schema}
      />
      <div className="min-h-screen bg-white">
        <Navbar />

        {/* Hero Section */}
        <section className="pt-32 pb-16 px-6 bg-gradient-to-br from-coral-50 to-white">
          <div className="max-w-7xl mx-auto text-center">
            <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>
              Connect With Us
            </h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-8">
              Follow our journey as we transform properties and help hosts succeed. Get daily tips, inspiration, and behind-the-scenes content across all platforms.
            </p>

            {/* Social Links */}
            <div className="flex flex-wrap justify-center gap-4 mb-8">
              {socialPosts.map((social) => (
                <a
                  key={social.platform}
                  href={social.profileUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`flex items-center gap-3 px-6 py-3 bg-gradient-to-r ${social.color} text-white rounded-full font-semibold hover:shadow-lg transition-all duration-300 cursor-pointer whitespace-nowrap`}
                >
                  <i className={`${social.icon} text-xl`}></i>
                  <span>Follow on {social.platform}</span>
                </a>
              ))}
            </div>
          </div>
        </section>

        {/* Featured Posts */}
        <section className="py-20 px-6">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-16">
              <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
                Latest Posts
              </h2>
              <p className="text-xl text-gray-600">
                Check out our recent content and join the conversation
              </p>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {socialPosts.map((post) => (
                <div key={post.platform} className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300">
                  {/* Platform Header */}
                  <div className={`${post.bgColor} px-6 py-4 flex items-center justify-between`}>
                    <div className="flex items-center gap-3">
                      <i className={`${post.icon} text-2xl text-white`}></i>
                      <span className="text-white font-bold text-lg">{post.platform}</span>
                    </div>
                    <a
                      href={post.profileUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-white/80 hover:text-white transition-colors cursor-pointer"
                    >
                      <i className="ri-external-link-line text-xl"></i>
                    </a>
                  </div>

                  {/* Post Image */}
                  <div className="relative h-80 overflow-hidden">
                    <img
                      src={post.postImage}
                      alt={`${post.platform} post`}
                      className="w-full h-full object-cover object-top"
                      onError={(e) => {
                        const target = e.target as HTMLImageElement;
                        target.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAwIiBoZWlnaHQ9IjQwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iNDAwIiBoZWlnaHQ9IjQwMCIgZmlsbD0iI2Y0ZjRmNCIvPjx0ZXh0IHg9IjUwJSIgeT0iNTAlIiBmb250LXNpemU9IjE4IiBmaWxsPSIjOTk5IiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBkeT0iLjNlbSI+SW1hZ2Ugbm90IGF2YWlsYWJsZTwvdGV4dD48L3N2Zz4=';
                      }}
                    />
                  </div>

                  {/* Post Content */}
                  <div className="p-6">
                    <p className="text-gray-700 text-sm leading-relaxed mb-4 line-clamp-4">
                      {post.caption}
                    </p>

                    {/* Stats */}
                    <div className="flex flex-wrap gap-4 mb-4 text-sm text-gray-600">
                      {Object.entries(post.stats).map(([key, value]) => (
                        <div key={key} className="flex items-center gap-1">
                          <i className={`${
                            key === 'views' ? 'ri-eye-line' :
                            key === 'likes' || key === 'reactions' ? 'ri-heart-line' :
                            key === 'comments' || key === 'replies' ? 'ri-chat-3-line' :
                            key === 'shares' || key === 'reposts' || key === 'retweets' ? 'ri-share-line' :
                            key === 'saves' ? 'ri-bookmark-line' :
                            key === 'subscribers' ? 'ri-user-add-line' :
                            'ri-star-line'
                          } text-coral-500`}></i>
                          <span className="font-semibold">{value}</span>
                        </div>
                      ))}
                    </div>

                    {/* Action Buttons */}
                    <div className="flex gap-2">
                      <button
                        onClick={() => handleShare(post.postUrl, post.platform)}
                        className="flex-1 bg-coral-500 text-white py-2 px-4 rounded-lg hover:bg-coral-600 transition-colors font-medium text-sm whitespace-nowrap cursor-pointer"
                      >
                        View Post
                      </button>
                      <button
                        onClick={() => handleCopyLink(post.postUrl, post.platform)}
                        className="bg-gray-100 text-gray-700 py-2 px-4 rounded-lg hover:bg-gray-200 transition-colors font-medium text-sm whitespace-nowrap cursor-pointer"
                        title="Copy link"
                      >
                        {copiedPost === post.platform ? (
                          <i className="ri-check-line"></i>
                        ) : (
                          <i className="ri-link"></i>
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-20 px-6 bg-gradient-to-br from-coral-500 to-coral-600">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>
              Ready to Transform Your Property?
            </h2>
            <p className="text-xl text-white/90 mb-8">
              Join hundreds of successful hosts who have transformed their properties with our expert guidance.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="/contact"
                className="inline-block bg-white text-coral-500 font-semibold py-4 px-10 rounded-lg hover:bg-gray-50 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
              >
                Schedule Consultation
              </a>
              <a
                href="tel:302-500-3373"
                className="inline-block bg-transparent border-2 border-white text-white font-semibold py-4 px-10 rounded-lg hover:bg-white hover:text-coral-500 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                Call: 302-500-3373
              </a>
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </>
  );
}
